<template>
	<div id="top">
		<div class="top_l">
			<div class="top_l1 cursor_1" @click="toHome">
				<img class="top_l2" src="../assets/logo.png" alt="">
				<img class="top_l3" src="../assets/image/top_icon.png" alt="">
			</div>
			<div class="top_l4">
				<div class="cursor_1 top_l5" :class="localTopIndex == i ? 'top_l6' : ''" v-for="(item, i) in topTitle"
					:key="i" @click="topSelect(i)">
					{{ item }}
					<!-- <div v-if="localTopIndex == i" class="top_l7"></div> -->
				</div>
			</div>
			<div class="top_r t-m-l-20">
				<div class="top_r1"
					v-if="!userInfo || userInfo?.vipType == 'common' || userInfo?.vipType == 'cmember'">
					<img src="@/assets/image/home/lw.png" width="43" height="35" />
					<!-- <div class="top_r2">{{ freeNum }}</div> -->
					<div class="top_r2">{{ $validata.formatNumberToUnit(freeNum, 1) }}</div>
					<div class="top_r3"> {{ userInfo ? '剩余字符' : '新人免费领取字符' }} </div>
				</div>
				<!-- <div class="vip_kaitong t-m-r-24 cursor_1" v-if="userInfo && getUserTypeImg(userInfo).name ==='普通会员'" @click.stop="openVip">
				<img src="@/assets/image/home/hg.png" width="21" height="18" /><span class="t-m-l-7">开通会员</span>
			</div> -->
				<el-popover placement="bottom" :disabled="userInfo?false:true" :visible-arrow="true" @show="isShow" trigger="hover"
					popper-class="top-popper" v-model="visible">
					<userPopup :userInfo="userInfo" v-if="userInfo"></userPopup>
					<div slot="reference" class="top_r4 top_r_max" @click="openUser">
						<img :src="userInfo ? headImg[0] : headImg[1]" alt="">
						<div class="top_r6" v-if="userInfo">
							<img v-if="userInfo && Object.keys(userInfo).length > 0"
								:src="getUserTypeImg(userInfo).img" alt="">
						</div>
						<div class="top_r5" v-else>未登录</div>
					</div>
				</el-popover>
			</div>
		</div>

		<login></login>
		<delPopup1></delPopup1>
	</div>
</template>

<script>
import data from '@/assets/data';
import userPopup from '../components/user_popup.vue' //个人信息
import login from '../components/login.vue' //登录
import delPopup1 from './del_popup1.vue';
import { EventBus } from '@/utils/eventBus';
import api from '@/api/api';
export default {
	mixins: [],
	components: {
		userPopup, login, delPopup1
	},
	props: {
		topIndex: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			headImg: data.headImg, //用户头像
			topTitle: data.topTitle, //顶部title
			localTopIndex: this.topIndex, // 本地数据属性，初始值为 prop 的值
			visible: false,
		}
	},
	watch: {
		topIndex(newValue) {
			this.localTopIndex = newValue; // 监听 prop 的变化，更新本地数据属性
		}
	},
	created() {
		const search = window.location.search
		if (search) {
			const query = {}
			const params = search.substring(1).split('&')
			for (let param of params) {
				const tmp = param.split('=')
				if (tmp.length == 2) {
					query[tmp[0]] = tmp[1]
				}
			}
			if (query.code) {
				this.wxLogin(query.code)
				return
			}
		}
		this.getUserInfo()
		console.log(this.$store.getters.userInfo)
	},
	mounted() {
		EventBus.$on('close', () => {
			this.visible = false
		})
	},
	computed: {
		userInfo() {
			return this.$store.getters.userInfo
		},
		freeNum(){
			return this.$store.getters.freeNum
		}
	},
	methods: {
		isShow() {
			if (Object.keys(this.$store.getters.userInfo).length > 0) {
				this.visible = true
			} else {
				this.visible = false
			}
		},
		wxLogin(code) {
			const params = {
				code: code,
				module: 'novel_pc'
			}
			api.wxLogin(params).then((res) => {
				localStorage.setItem('token_key', res.data.access_token)
				location.href = '/'
			})
		},
		topSelect(i) {
			if (this.localTopIndex == i) return
			this.localTopIndex = i;
			this.routerPathJump(i)
		},
		openVip() {
			EventBus.$emit('openVip')
		},
		openUser() {
			console.log('openUser=', this.$store.getters.userInfo)
			if (this.$store.getters.userInfo) {
				this.visible = !this.visible
				EventBus.$emit('openUserinfo')
			} else {
				this.visible = false
				EventBus.$emit('openLogin')
			}
		},
		toHome() {
			this.$router.replace('/')
		}
	}
}
</script>

<style>
#top {
	flex-shrink: 0;
	height: 60px;
	background-color: #FFFFFF;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 22px 0 0;
	position: relative;
}

.top_l {
	display: flex;
	flex: 1;
	margin-right: 20px;
}

.top_l1 {
	display: flex;
	align-items: center;
	width: 250px;
	padding-left: 44px;
}

.top_l2 {
	width: 45px;
	height: 45px;
}

.top_l3 {
	width: 91.4px;
	height: 24px;
	margin-left: 6px;
}

.top_l4 {
	display: flex;
	align-items: center;
	font-size: 16px;
	color: #666666;
	margin-left: 30px;
}

.top_l5 {
	margin-right: 5px;
	min-width: 100px;
	padding: 0 5px;
	position: relative;
	height: 40px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #000000;
	font-size: 16px;
	border-radius: 10px;
	transition: all 0.3 ease;

}

.top_l5:last-child {
	margin-right: 0;
}

.top_l5:hover {
	font-weight: bold;
	/* 文字放大1.1倍 */
	font-family: Microsoft YaHei;
	background-color: var(--tech-table-bg);
}

.top_l6 {
	font-weight: bold;
	font-family: Microsoft YaHei;
	background-color: var(--tech-table-bg);
}

.top_l7 {
	width: 31px;
	height: 5px;
	background: #FF6603;
	border-radius: 3px 3px 3px 3px;
	position: absolute;
	left: 50%;
	transform: translate(-50%);
	bottom: -10px;
}

.top_r {
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #333333;
	position: relative;
}

.top_r1 {
	background: var(--tech-home-bg);
	border: 1px solid var(--tech-btn-border1);
	display: flex;
	align-items: center;
	height: 39px;
	padding: 0px 15px;
	border-radius: 30px;
	font-size: 15px;
	margin-right: 30px;
	flex-shrink: 0;
}

.top_r2 {
	color: #C36C1D;
	padding-right: 5px;
}

.top_r3 {
	color: #000000;
	font-weight: bold;
	padding-left: 5px;
	position: relative;
}

.top_r3::before {
	position: absolute;
	content: ' ';
	height: 70%;
	top: 4px;
	padding: 0 10px;
	left: 0;
	border-left: 1px solid #AFDBFF;
}

.top_r4 {
	position: relative;
}

.top_r4 img {
	width: 50px;
	height: 50px;
	border-radius: 50%;
	cursor: pointer;
}

.top_r5 {
	position: absolute;
	bottom: -2px;
	left: 50%;
	width: 67px;
	transform: translate(-50%);
	text-align: center;
	font-size: 13px;
	padding: 2px 0;
	color: #FFFFFF;
	background-color: #999999;
	border-radius: 20px;
}

.top_r6 {
	width: 80px;
	height: 24px;
	position: absolute;
	bottom: 0px;
	left: 50%;
	transform: translate(-50%);
	cursor: pointer;
}

.top_r6 img {
	width: 100%;
	height: 100%;
	border-radius: 0;

}

.top-popper {
	background-color: transparent !important;
	border: 0 !important;
	box-shadow: none !important;
	padding: 0 !important;
	font-size: 20px;
}

.vip_kaitong {
	width: 120px;
	height: 38px;
	font-size: 14px;
	font-weight: bold;
	background: linear-gradient(91deg, #FFE496, #FFF6D6);
	border-radius: 20px;
	border: 1px solid #FFD071;
	display: flex;
	align-items: center;
	justify-content: center;
}

@media (max-width: 1200px) {
	.top_l1 {
		display: none;
		opacity: 0;
	}
}
</style>
